import FeatherIcon from 'feather-icons-react';
import React, { useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

const KeyboardShortcutsHelp: React.FC = () => {
  const [show, setShow] = useState(false);

  const shortcuts = [
    {
      category: 'Navegação',
      items: [
        { keys: ['Espaço'], description: 'Play / Pause' },
        { keys: ['A', '←'], description: 'Voltar 1 frame' },
        { keys: ['D', '→'], description: 'Avançar 1 frame' },
        { keys: ['W', '↑'], description: 'Voltar 5 frames' },
        { keys: ['S', '↓'], description: 'Avançar 5 frames' }
      ]
    },
    {
      category: 'Sinalizações',
      items: [
        { keys: ['ESC'], description: 'Limpar seleção' },
        { keys: ['Clique'], description: 'Selecionar sinalização' },
        { keys: ['Duplo Clique'], description: 'Editar sinalização' }
      ]
    },
    {
      category: 'Zoom',
      items: [
        {
          keys: ['Ctrl', 'Scroll'],
          description: 'Zoom in/out (onde está o mouse)'
        },
        { keys: ['Ctrl', '+'], description: 'Zoom in' },
        { keys: ['Ctrl', '-'], description: 'Zoom out' },
        { keys: ['Ctrl', '0'], description: 'Resetar zoom (100%)' },
        { keys: ['Arrastar'], description: 'Mover imagem (quando com zoom)' }
      ]
    }
  ];

  return (
    <>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setShow(true)}
        title="Atalhos de teclado"
        className="p-1"
        style={{ width: '32px', height: '32px' }}
      >
        <FeatherIcon icon="help-circle" size={14} />
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FeatherIcon icon="keyboard" size={20} className="me-2" />
            Atalhos de Teclado
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {shortcuts.map((section, idx) => (
            <div key={idx} className={idx > 0 ? 'mt-4' : ''}>
              <h6 className="text-muted mb-2">
                <FeatherIcon icon="arrow-right" size={14} className="me-1" />
                {section.category}
              </h6>
              <Table size="sm" className="mb-0">
                <tbody>
                  {section.items.map((item, itemIdx) => (
                    <tr key={itemIdx}>
                      <td style={{ width: '40%' }}>
                        <div className="d-flex gap-1 flex-wrap">
                          {item.keys.map((key, keyIdx) => (
                            <kbd
                              key={keyIdx}
                              className="bg-light text-dark border"
                              style={{
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontWeight: 'bold'
                              }}
                            >
                              {key}
                            </kbd>
                          ))}
                        </div>
                      </td>
                      <td>{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ))}

          <div className="mt-4 p-2 bg-light rounded">
            <small className="text-muted">
              <FeatherIcon icon="info" size={12} className="me-1" />
              <strong>Dica:</strong> Os atalhos não funcionam quando você está
              digitando em campos de texto.
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default KeyboardShortcutsHelp;
